import React, { useEffect } from "react";
import LockedPage from "../Locked";
import { useNavigationBar } from "../../context/NavigationContext";
import ContainerNavigation from "../../components/ContainerNavigation";
import { useNavigate } from "react-router-dom";

const Analytics = () => {
  const { setNavProps, navProps } = useNavigationBar();

  const navigate = useNavigate();
  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Ananlytics",
      subtitle: "Channel",
      buttonTitle: "Next",
      filterOption: false,
      enableLink: true,
      onBack: () => alert("Back Clicked"),
      onFilter: () => {},
      onNext: () => navigate("../channels"),
    });
  }, [setNavProps, navigate]);

  const { backArrow, title, subtitle, buttonTitle, enableLink, filterOption, onBack, onFilter, onNext } = navProps;

  return (
    <>
      <ContainerNavigation
        backArrow={backArrow}
        title={title}
        subtitle={subtitle}
        enableLink={enableLink}
        buttonTitle={buttonTitle}
        filterOption={filterOption}
        onBack={onBack}
        onFilter={onFilter}
        onNext={onNext}
      />
      <LockedPage content="manage analytics" />
    </>
  );
  //
};

export default Analytics;
